<template>
	<div>
		<div class="text-center mt-12" style="max-width:800px;margin:auto">
			<p><b>Welcome to the CASE Network GUID Translator tool.</b></p>
			<p>In this beta version of the tool, users must sign in using a Google account, and must be pre-authorized by Bruce Umpstead (<a href="mailto:bumpstead@imsglobal.com">bumpstead@imsglobal.com</a>).</p>
			<img ref="google_signin_btn" class="k-google_signin_btn" src="images/btn_google_signin_dark_normal_web@2x.png">
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() { return {
	}},
	computed: {
		...mapState(['google_client_id']),
	},
	created() {

	},
	mounted() {
		this.initialize()
	},
	methods: {
		initialize() {
			U.loading_start()
			// window.gapi should be loaded via https://apis.google.com/js/platform.js in index.html
			// if it isn't loaded yet, try again in 100 ms
			if (window.gapi == null) {
				setTimeout(()=>this.initialize(), 100);
				return;
			}
			U.loading_stop()

			window.gapi.load('auth2', () => {
				var auth2 = window.gapi.auth2.init({
					client_id: this.google_client_id,
					scope: 'profile email ',
					fetch_basic_profile: true,
					approval_prompt: 'force',
					prompt: 'select_account consent',
					access_type: 'offline'
					// cookiepolicy: 'single_host_origin'
				})

				auth2.attachClickHandler(this.$refs.google_signin_btn, {}, googleUser => {
					// The ID token you need to pass to your backend:
					let id_token = googleUser.getAuthResponse().id_token
					// console.log('attachClickHandler fn called', googleUser.getAuthResponse())

					if (id_token) {
						// pass id_token back to initialize_portal service, which will sign the user in
						vapp.initialize_app({id_token: id_token})
					} else {
						// TODO: what do we do here?
						alert('Google getAuthResponse failed')
					}
				}, error => console.error(error))
			})
		},
	}
}
</script>

<style lang="scss">
.k-google_signin_btn {
	cursor:pointer;
	max-width:90%;
	margin:50px auto 0 auto;
}
</style>
